<ngx-spinner></ngx-spinner>
<section class="container-table">
  <div class='row'>
    <div class="col-6">
      <h1 class="mb-0 fs-2 fw-bold">{{ contentTypeData.edit_title }}</h1>
    </div>
    <div class="col-6">
      <div class="text-end">
        <button class="btn_primary mb-3" [routerLink]="[contentTypeData.backLink]" *ngIf="contentTypeData.hasBackLink">
          Back
        </button>
      </div>
    </div>
  </div>
</section>
<section class="container-table my-3"  *ngIf="recordData!=null">
  <form [formGroup]="mainForm">
    <div class="section-details">
      <div class="form-group">
        <!-- <div class="row"> -->
        <!-- End OF Render Arabic Fields -->
        <div class="pe-5">
          <!-- Render English Fields -->
          <div class="row"  >
            <div class="field col-md-6" *ngFor="let field of contentTypeData[action]; let i = index">
              <div *ngIf="field.type != 'hidden'">

                <label class="form-control-label" [ngClass]="{ required: field.required }" [attr.for]="field.label"> {{
                field.label }}:
                </label>


                <div [ngSwitch]="field.type">


                  <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'">
                    <input matInput formControlName="{{field.name}}" />
                  </mat-form-field>

                  <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'password'">
                    <input matInput type="password" formControlName="{{field.name}}" />
                  </mat-form-field>
                  <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'new'">
                    <input matInput type="password" formControlName="{{field.name}}" />
                  </mat-form-field>
                  <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'confirm'">
                    <input matInput type="password" formControlName="{{field.name}}" />
                    <small
                      *ngIf="mainForm.get('new_password_confirmation').value!=mainForm.get('password').value && type=='confirm' "
                      class="text-danger font-14">Passwords do not
                      match.</small>
                  </mat-form-field>
                  <div class="img-field" *ngSwitchCase="'file'">
                    <input type="file" (change)="upload($event, field.name)" hidden id="{{field.name+'-field'}}"
                      accept="image/png, image/gif, image/jpeg, video/mp4,video/x-m4v,video/*" />
                    <div class="table_image" (click)="triggerClick(field.name+'-field')"
                      [ngClass]="{'replace-img':imageSrc[field.name]!='null'}">


                      <img [src]="imageSrc[field.name]" class="img_fit"
                        *ngIf="imageSrc[field.name]!='null' " />



                      <img src="assets/images/no-image-placeholder.png" *ngIf="imageSrc[field.name]=='null' "
                        class="img-fluid" />

                      <div class="text-replace-img">
                        Replace File
                      </div>

                    </div>

                    <small *ngIf="imageSizeError[field.name]" class="text-danger font-14 d-block">The file size must not
                      exceed 5MB</small>
                    <small class="text-danger font-14"
                      *ngIf="contentTypeData.hasImageDimensions">{{ dimensions[field.name] }}</small>
                  </div>










                </div>
              </div>
            </div>
          </div>

        </div> <!-- End of Render English Fields -->
        <!-- End Of Render Arabic Fields -->
        <!-- </div> -->
      </div>
    </div>


    <div class="col-md-12">
      <button type="submit" (click)="openDialog()" class="btn btn_primary mx-2">Save
        changes</button>
    </div>
  </form>
</section>
